export default "__VITE_ASSET__72bf02fa__"